/**
 * @export
 * @class Home
 */
import { BaseModule } from '../../helpers/base_module';

import { Fullpage } from './fullpage';

export class Home extends BaseModule {
    public static id = 'home';
    public fullPage: Fullpage;

    
    /**
     * Creates an instance of Global.
     * 
     * @memberof Global
     */
    constructor() {
        super();
        super.makePublic('home');

        // Initiate our classes
        this.fullPage = new Fullpage();
    }
}
